// GENERAL
export const BRDGE_PROJECT_ID = "ubs" // can be any string, will be used to namespace cookies (so that two "brdge projects" seamlessly work without clearing cookies)

// LOCALES
export const AVAILABLE_LOCALES = ["en", "de", "fr", "it"] as const
export const DEFAULT_LOCALE = "de"

// MISC
export const WITH_DELAY = false
